import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Courses from './pages/Courses';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Post from "./pages/Post";
import Coursessingle from "./pages/Coursessingle";
import Thankyou from "./pages/Thankyou";
import Aboutus from "./pages/Aboutus";
import SuccessPage from "./pages/SuccessPage";
import Oneonone from "./pages/Oneonone";
import Fivedays from "./pages/Fivedays";
import Oneweekdays from "./pages/Oneweekdays";
import Twoweekdays from "./pages/Twoweekdays";
import Stylingwithbhavna from "./pages/Stylingwithbhavna";
import Wardrobe from "./pages/Wardrobe";
import Thebridal from "./pages/Thebridal";
import Onemonthstyling from "./pages/Onemonthstyling";
import CancellationPolicy from "./pages/CancellationPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsandConditions from "./pages/TermsandConditions";




const App = () => {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/personality-development-courses" element={<Courses />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:slug" element={<Post />} />
        <Route path="/courses/:slug" element={<Coursessingle />} />
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/one-on-one-transformation" element={<Oneonone />} />
        <Route path="/five-day-transformation" element={<Fivedays />} />
        <Route path="/one-week-transformation" element={<Oneweekdays />} />
        <Route path="/two-week-transformation" element={<Twoweekdays />} />
        <Route path="/styling-with-bhavna" element={<Stylingwithbhavna />} />
        <Route path="/wardrobe" element={<Wardrobe />} />
        <Route path="/the-bridal-trousseau-styling" element={<Thebridal />} />
        <Route path="/one-month-styling-transformation" element={<Onemonthstyling />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
      </Routes>
      <Footer />
    </div>
  );
};



export default App;